import {
  listSortType,
  listSortTypeToSelect,
} from "../../global/GlobalVariables";
import { deduplicateArray, updateClassifiactionSurebet } from "../../global/GlobalFunctions";
import React, { useEffect, useContext, useState, useRef } from "react";
import {
  listBettingHousesNoClone,
  allSportsMinuscle,
} from "../variables/VariablesFilterSurebet";
import {
  listMarketsOnfilterMarket,
  normalBetHomeLower,
} from "../variables/VariablesFilterSurebet";
import { Context } from "../../App";
import { saveWordOnBlackListWords } from "../functions/FunctionsFilter";
import { setClearOldSurebet } from "../functions/FunctionsFilter";
import Confirm from "../Modal/Confirm";

const Main = (props) => {
  const {
    openFilterBethome,
    openFilterSports,
    statusMode,
    controllerLocalStorage,
    valueMin,
    setValueMin,
    valueMax,
    setValueMax,
    quantityBetHomeEnabled,
    quantitySportsEnabled,
    timeEvent,
    setTimeEvent,
    setSports,
    setBetHome,
    saveFilterSports,
    saveFilterBetHome,
    setentradasLigth,
    entradasLigth,
    setentradasPro,
    entradasPro,
    filterOrder,
    setFilterOrder,
    saveFilterChanged,
    requiredBetHome,
    setRequiredBetHome,
    openFilterMarkets,
    openFilterEvent,
  } = props;

  const {
    marketsUnselected,
    setMarketsUnselected,
    clearOldSurebet,
    blacklistWords,
    setBlacklistWords,
    accountFeatures,
    threeHouseEntryisActivated,
    setThreeHouseEntryisActivated,
    entradasGlobal,
    setEntradasGlobal,
  } = useContext(Context);

  const [showResetModal, setShowResetModal] = useState(false);
  const resetFunctionRef = useRef(() => {});

  const setValue = {
    profitMin: (
      paramenterValueMin,
      keyLocalStorage,
      saveMinFilterInCloud = false,
    ) => {
      if (saveMinFilterInCloud === true) {
        saveFilterChanged({ actualMinProfit: paramenterValueMin });
      }

      setValueMin(paramenterValueMin);
      controllerLocalStorage["updateLocalStorage"](
        keyLocalStorage,
        paramenterValueMin,
      );
    },
    profitMax: (
      parameterValueMax,
      keyLocalStorage,
      saveMaxFilterInCloud = false,
    ) => {
      if (saveMaxFilterInCloud === true) {
        saveFilterChanged({ actualMaxProfit: parameterValueMax });
      }

      setValueMax(parameterValueMax);
      controllerLocalStorage["updateLocalStorage"](
        keyLocalStorage,
        parameterValueMax,
      );
    },
  };

  const handleChange = (event) => {
    const { value, id } = event.target;
    setValue[id](value, id, true);
  };

  function changeTime(event) {
    const { name } = event.target;

    saveFilterChanged({
      actuaTimeEvent: name,
    });
    setTimeEvent(name);
    controllerLocalStorage["updateLocalStorage"]("time", name);
  }
  //
  function filterReset() {
    setTimeEvent("Qualquer Horário");
    controllerLocalStorage["updateLocalStorage"]("time", "Qualquer Horário");
    setValue["profitMin"](-999, "profitMin");
    setValue["profitMax"](999, "profitMax");
    
    setSports(allSportsMinuscle);
    saveFilterSports(allSportsMinuscle);
    
    //
    //
    //
    //

    let bettingHouseReseted = deduplicateArray( JSON.parse(
      JSON.stringify(listBettingHousesNoClone),
    ) );

    let bettingHouseResetedStorage = deduplicateArray( JSON.parse(
      JSON.stringify(listBettingHousesNoClone),
    ));
    
    

    if (accountFeatures.current.includes("global") === false) {
      bettingHouseReseted = bettingHouseReseted.filter((item) =>
        normalBetHomeLower.includes(item),
      );
    }
    
    setBetHome(bettingHouseReseted);
    
    saveFilterBetHome(bettingHouseResetedStorage);

    setRequiredBetHome([]);
    localStorage.setItem("riquiredsBethome", JSON.stringify([]));

    saveFilterChanged({
      actualBethomeEnable: bettingHouseResetedStorage,
      actualSportsEnabled: allSportsMinuscle,
      actuaTimeEvent: "Qualquer Horário",
      actualMinProfit: -999,
      actualMaxProfit: 999,
      marketsUnselected: [],
      actualOrderBet: "lucro",
    });
    setFilterOrder("lucro");
    setMarketsUnselected([]);
    localStorage.setItem("marketsUnselected", JSON.stringify([]));
    saveWordOnBlackListWords([], setBlacklistWords);
  }

  function handleResetClick() {
    resetFunctionRef.current = filterReset;
    setShowResetModal(true);
  }

  function EnabledDisablebEntradas(event) {
    const { checked, name } = event.target;

    controllerLocalStorage["updateLocalStorage"](name, checked);
    if (name === "entradaslight") {
      setentradasLigth(checked);
    } else if (name === "entradaspro") {
      setentradasPro(checked);
    } else if (name === "threeHouseEntryisActivated") {
      setThreeHouseEntryisActivated(checked);
    } else if (name === "entradasGlobal") {
      setEntradasGlobal(checked);
    }
    setClearOldSurebet(clearOldSurebet);
  }

  useEffect(() => {
    if (filterOrder in listSortTypeToSelect === false) {
      setFilterOrder("lucro");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className={`boxHeader p-2 border-bottom ${
          statusMode ? "borderColor" : ""
        }`}
      >
        <div className="boxOptions">
          <div
            className={`text-Filter p-0 m-0 fw-bold text-center ${
              statusMode ? "textGray" : ""
            }`}
          >
            FILTROS
          </div>
        </div>
      </div>
      <div
        id="filter"
        className="px-4 d-flex flex-column align-items-center filter fs-6"
      >
        <p
          className={` text-faixa-lucro mt-2 mb-2 ${
            statusMode ? "textGray" : ""
          } fs-6`}
        >
          Faixa de lucro (min/max)
        </p>
        <div className=" d-flex align-items-center mb-2">
          <input
            id="profitMin"
            style={{
              width: "100px",
              height: "45px",
              backgroundColor: statusMode ? "#0d0d0d" : "",
            }}
            type="number"
            className={`form-control fs-5 ${
              statusMode ? "borderColor textGray" : ""
            }`}
            placeholder="0.00"
            onChange={handleChange}
            value={valueMin}
          />
          <span className=" mx-2 fs-5">/</span>
          <input
            id="profitMax"
            style={{
              width: "100px",
              height: "45px",
              backgroundColor: statusMode ? "#0d0d0d" : "",
            }}
            type="number"
            className={`form-control fs-5 ${
              statusMode ? "borderColor textGray" : ""
            }`}
            placeholder="0.00"
            onChange={handleChange}
            value={valueMax}
          />
        </div>

        <div
          className="dropdown fs-5 d-flex flex-column align-items-center mt-3"
          id="filter_time"
        >
          <button
            className={`dropdown-toggle btn btn-success ${
              statusMode ? "" : ""
            } `}
            style={{ background: "#2a960d", color: "white" }}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Evento Durante
          </button>
          <ul
            className={`dropdown-menu ${
              statusMode ? "bgDark borderColor" : ""
            }`}
          >
            <li>
              <button
                className={`dropdown-item fs-6   ${
                  "Qualquer Horário" === timeEvent ? "active" : ""
                } ${statusMode ? "textGray hoverGray" : ""}`}
                name="Qualquer Horário"
                onClick={changeTime}
              >
                Qualquer Horário
              </button>
            </li>
            <li>
              <button
                className={`dropdown-item fs-6  ${
                  "6 Horas" === timeEvent ? "active" : ""
                } ${statusMode ? "textGray hoverGray" : ""}`}
                name="6 Horas"
                onClick={changeTime}
              >
                6 Horas
              </button>
            </li>
            <li>
              <button
                className={`dropdown-item fs-6  ${
                  "12 Horas" === timeEvent ? "active" : ""
                } ${statusMode ? "textGray hoverGray" : ""}`}
                name="12 Horas"
                onClick={changeTime}
              >
                12 Horas
              </button>
            </li>
            <li>
              <button
                className={`dropdown-item fs-6  ${
                  "16 Horas" === timeEvent ? "active" : ""
                } ${statusMode ? "textGray hoverGray" : ""}`}
                name="16 Horas"
                onClick={changeTime}
              >
                16 Horas
              </button>
            </li>
            <li>
              <button
                className={`dropdown-item fs-6  ${
                  "1 Dia" === timeEvent ? "active" : ""
                } ${statusMode ? "textGray hoverGray" : ""}`}
                name="1 Dia"
                onClick={changeTime}
              >
                1 Dia
              </button>
            </li>
          </ul>
        </div>
        <div className="text-center ">
          <span
            id="badge_time_event"
            className={`badge rounded-pill text-white bg-primary  ${
              statusMode ? "" : ""
            } `}
          >
            {timeEvent}
          </span>
        </div>

        <div className="mt-3">
          <button
            type="button"
            className="btn btn-success dropdown-toggle text-light default-green "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Ordenar por
          </button>
          <ul className="dropdown-menu custom-theme-dropdown">
            {listSortType.map((itemSort, indexSort) => {
              return (
                <li
                  className={`curso-pointer ${filterOrder === itemSort.toLowerCase() ? "classificationActive" : ""}`}
                  key={indexSort}
                  onClick={() => {
                    updateClassifiactionSurebet(
                      itemSort,
                      setFilterOrder,
                      "classificationSurebet",
                    );
                    saveFilterChanged({
                      actualOrderBet: itemSort.toLocaleLowerCase(),
                    });
                  }}
                >
                  <span className="dropdown-item ">{itemSort}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="text-center" style={{ width: "115px" }}>
          <span
            id="badge_time_event"
            className={`badge rounded-pill text-white bg-primary  ${
              statusMode ? "" : ""
            }`}
          >
            {filterOrder in listSortTypeToSelect === true
              ? listSortTypeToSelect[filterOrder]
              : "Lucro"}
          </span>
        </div>

        <button
          id="btn_filter_bet_home_mobile"
          className={`mt-4 fw-bolder fs-6 textDecoration ${
            statusMode ? "textGray" : "textGray-update2"
          }`}
          style={{ cursor: "pointer" }}
          onClick={openFilterBethome}
        >
          Casas de Apostas{" "}
          <span
            id="qt_bet_home_selected"
            className=""
            style={{
              color: "#ced2d6!important",
              borderRadius: "30%",
              padding: "3px",
              fontSize: "0.9rem",
            }}
          >
            {" "}
            <b> ({quantityBetHomeEnabled})</b>{" "}
          </span>
          {requiredBetHome.length >= 1 ? (
            <div className="text-light text-center bg-primary rounded-5 ">
              {requiredBetHome.length} em prioridade
            </div>
          ) : (
            ""
          )}
        </button>

        <span
          id="btn_filter_sports"
          className={`fw-bolder fs-6 textDecoration ${
            statusMode ? "textGray" : "textGray-update2"
          }`}
          style={{ cursor: "pointer" }}
          onClick={openFilterSports}
        >
          Esportes{" "}
          <span
            id="qt_sports_selected"
            className=""
            style={{
              color: "#ced2d6!important",
              borderRadius: "30%",
              padding: "3px",
              fontSize: "1rem",
            }}
          >
            {" "}
            <b>({quantitySportsEnabled}) </b>{" "}
          </span>
        </span>

        <span
          id="btn_filter_sports"
          className={`fw-bolder fs-6 textDecoration ${statusMode ? "textGray" : "textGray-update2"}`}
          style={{ cursor: "pointer" }}
          onClick={openFilterMarkets}
        >
          Mercados{" "}
          <span
            id="qt_sports_selected"
            className=""
            style={{
              color: "#ced2d6!important",
              borderRadius: "30%",
              padding: "3px",
              fontSize: "1rem",
            }}
          >
            {" "}
            <b>
              ({listMarketsOnfilterMarket.length - marketsUnselected.length})
            </b>{" "}
          </span>
        </span>

        <span
          id="btn_filter_sports"
          className={`fw-bolder fs-6 textDecoration ${statusMode ? "textGray" : "textGray-update2"}`}
          style={{ cursor: "pointer" }}
          onClick={openFilterEvent}
        >
          Excluir eventos
          <span
            id="qt_sports_selected"
            className=""
            style={{
              color: "#ced2d6!important",
              borderRadius: "30%",
              padding: "3px",
              fontSize: "1rem",
            }}
          >
            <b> ({blacklistWords.length}) </b>
          </span>
        </span>

        <div className="d-flex flex-column align-items-end">
          {accountFeatures.current.includes("light") &&
            accountFeatures.current.includes("pro") && (
              <>
                <div className="form-check p-0 d-flex align-items-center">
                  <label
                    id="btn_filter_sports"
                    className={`fw-bolder fs-6 textDecoration ${
                      statusMode ? "textGray" : "textGray-update2"
                    } form-check-label p-0`}
                    style={{ cursor: "pointer" }}
                  >
                    Entradas Light
                  </label>
                  <input
                    type="checkbox"
                    id={"ligth"}
                    className="form-check-input m-0 ms-2 position-relative"
                    name={"entradaslight"}
                    checked={entradasLigth}
                    onChange={EnabledDisablebEntradas}
                  />
                </div>
              </>
            )}
          {accountFeatures.current.includes("light") &&
            accountFeatures.current.includes("pro") && (
              <>
                <div className="form-check p-0 d-flex align-items-center">
                  <label
                    id="btn_filter_sports"
                    className={`fw-bolder fs-6 textDecoration ${
                      statusMode ? "textGray" : "textGray-update2"
                    } form-check-label p-0`}
                    style={{ cursor: "pointer" }}
                  >
                    Entradas Pro
                  </label>
                  <input
                    type="checkbox"
                    id={"pro"}
                    className="form-check-input m-0 ms-2 position-relative"
                    name={"entradaspro"}
                    checked={entradasPro}
                    onChange={EnabledDisablebEntradas}
                  />
                </div>

                <div className="form-check p-0 d-flex align-items-center">
                  <label
                    id="btn_filter_sports"
                    className={`fw-bolder fs-6 textDecoration ${
                      statusMode ? "textGray" : "textGray-update2"
                    } form-check-label p-0`}
                  >
                    3 casas
                  </label>
                  <input
                    type="checkbox"
                    id={"pro"}
                    className="form-check-input m-0 ms-2 position-relative"
                    name={"threeHouseEntryisActivated"}
                    checked={threeHouseEntryisActivated}
                    onChange={EnabledDisablebEntradas}
                  />
                </div>
              </>
            )}

          {accountFeatures.current.includes("global") && (
            <>
              <div className="form-check p-0 d-flex align-items-center">
                <label
                  id="btn_filter_sports"
                  className={`fw-bolder fs-6 textDecoration ${
                    statusMode ? "textGray" : "textGray-update2"
                  } form-check-label p-0`}
                  style={{ cursor: "pointer" }}
                >
                  Entradas Global
                </label>
                <input
                  type="checkbox"
                  id={"ligth"}
                  className="form-check-input m-0 ms-2 position-relative"
                  name={"entradasGlobal"}
                  checked={entradasGlobal}
                  onChange={EnabledDisablebEntradas}
                />
              </div>
            </>
          )}
        </div>

        <button
          type="button"
          id="filter_reset"
          className={`btn btn-primary alt_margin fs-5 my-3  ${
            statusMode ? "" : ""
          }`}
          onClick={handleResetClick}
        >
          Resetar Filtros
        </button>

        <Confirm
          messageModal="Deseja realmente resetar os filtros?"
          show={showResetModal}
          setShow={setShowResetModal}
          processData={resetFunctionRef.current}
          textConfirm="Confirmar"
          textCancel="Cancelar"
        />
      </div>
    </>
  );
};

export default Main;
